import type { RecordProxy, RecordSourceSelectorProxy } from 'relay-runtime';
import type { ProjectId, CloudId } from '@atlassian/jira-shared-types/src/general.tsx';

import type { MenuItemReorderOperation } from '../../../utils/constants.tsx';
import { reorder } from '../../../utils/reorder-list.tsx';

export function optimisticUpdater(
	store: RecordSourceSelectorProxy,
	operation: MenuItemReorderOperation,
	targetProjectId: ProjectId,
	cloudId: CloudId,
	relativeProjectId?: ProjectId,
): void {
	const sidebarMenuRecord = store
		.getRoot()
		.getLinkedRecord('jira_projectsSidebarMenu', { cloudId });
	const favoriteConnection =
		sidebarMenuRecord && sidebarMenuRecord.getLinkedRecord('favourites', { first: 15 });

	if (!favoriteConnection) {
		return;
	}

	const edges = favoriteConnection.getLinkedRecords('edges') ?? [];
	if (!edges.length || edges.length <= 1) {
		return;
	}

	const projectIdToEdgeMap = edges.reduce((map, edge) => {
		const projectId = edge.getLinkedRecord('node')?.getValue('projectId')?.toString();
		return projectId ? map.set(projectId, edge) : map;
	}, new Map<ProjectId, RecordProxy>());

	const projectIds = Array.from(projectIdToEdgeMap.keys());

	const sortedProjectIds = reorder(operation, projectIds, targetProjectId, relativeProjectId);

	const sortedEdges = sortedProjectIds.map(
		(projectId) => projectIdToEdgeMap.get(projectId) ?? null,
	);

	favoriteConnection.setLinkedRecords(sortedEdges, 'edges');
}
